import React, {useState} from "react";
import { PRODUCT_NAME, PUBLISHER } from "@/shared/config/constants";
import { useAgreeTerms } from "@/features/legal/hooks/use-agree-terms";
import { Checkbox } from "@/shared/components/check-box/check-box";
import { Link } from "react-router-dom";
import { TERMS_URL, PRIVACY_POLICY_URL } from "@/shared/config/constants";

interface Props {
  checked: boolean;
  onTapAgreement: () => void;
}

export const AgreeTermsCheckbox = ({
  checked,
  onTapAgreement,
}: Props) => {
  const {
    onClickTerms,
    onClickPrivacyPolicy
  } = useAgreeTerms();

  return (
    <>
      <Checkbox
        label="利用規約と個人情報保護基本方針に同意します"
        checked={checked}
        handleChange={onTapAgreement}
        className="signupTerms"
      />
      <p className="signupTermsDescription">
        ※ 本サービスをご利用いただくには、
        <a
          href={TERMS_URL}
          className=""
          tabIndex={0}
          target="_blank"
          rel="noopener noreferrer"
          >
          利用規約
        </a>
        並びに
        <a
          href={PRIVACY_POLICY_URL}
          className=""
          tabIndex={0}
          target="_blank"
          rel="noopener noreferrer"
          >
          個人情報保護基本方針
        </a>
        への同意が必要です。<br/>
        内容をご確認のうえ、チェックを入れて「メールを送信」をクリックしてください。
      </p>
    </>
  );
};
